import './App.css';
import Footer from './components/Footer';
import Grid from './components/Grid';
import Header from './components/Header';
import ImageGrid from './components/ImageGrid';
import Landing from './components/Landing';

function App() {
  return (
    <div className="App">
      <Header />
      <Landing />
      <Grid />
      <ImageGrid />
      <Footer />


    </div>
  );
}

export default App;
